// Constants
import { CookiesSameSiteType } from '@openbank/web-ui-framework';
// Enumerations
import { RoutesCommonEnumeration } from 'enumerations/routes.common.enumeration';

export const BASE_ROUTE = `/${RoutesCommonEnumeration.BASE_PATH}`,
  COOKIES_STORAGE_PROPS = {
    credentialsDomain: '.kunden.openbankpay.com',
    secure: false,
    path: '/',
    sameSite: undefined as CookiesSameSiteType,
  };
